module.exports = __webpack_public_path__ + "img/icon-promo-page.b5d0f132.jpeg";